module.exports = __webpack_public_path__ + "img/stack_3.76b909ff.png";